import React, { useState } from "react";
import "../styles/SignInPage.css";
import logoIcon from "../assets/mainicon.png";
import googleIcon from "../assets/googleicon.png";
import facebookIcon from "../assets/facebookicon.png";
import emailIcon from "../assets/Message.png";
import profileIcon from "../assets/Profile.png";
import passwordIcon from "../assets/Lock.png";
import viewIcon from "../assets/Show.png";
import hideIcon from "../assets/Hide.png";
import { auth, provider, db } from "../firebaseConfig";
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
const SignUpPage = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };

  const handleSignUp = async () => {
    setError("");
    setSuccess("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!username) {
      setError("Username is required");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      localStorage.setItem("user", JSON.stringify(user));
      const userDocRef = doc(db, "users", user.uid);
      const userDocSnapshot = await getDoc(userDocRef);

      if (!userDocSnapshot.exists()) {
        await setDoc(userDocRef, {
          username: username,
          email: email,
          points: 50,
        });
      }
      localStorage.setItem("points", 50);
      console.log("User signed up:", user);
      setSuccess("User signed up successfully!");
      navigate("/signin");
    } catch (error) {
      console.error("Error signing up:", error);
      setError(error.message);
    }
  };

  const handleGoogleSignIn = async () => {
    setError("");
    setSuccess("");

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const userDocRef = doc(db, "users", user.uid);
      const userDocSnapshot = await getDoc(userDocRef);

      if (!userDocSnapshot.exists()) {
        await setDoc(userDocRef, {
          username: user.displayName || "Google User",
          email: user.email,
          points: 50,
        });
        localStorage.setItem("points", 50);
        console.log("User got points");
      } else {
        console.log("User already have points");
        const userData = userDocSnapshot.data();
        localStorage.setItem("points", userData.points);
      }
      localStorage.setItem("user", JSON.stringify(user));
      console.log("User signed up with Google:", result);
      setSuccess("User signed up with Google successfully!");
      navigate("/process");
    } catch (error) {
      console.error("Error signing up with Google:", error);
      setError(error.message);
    }
  };

  return (
    <div className="login-page">
      <header className="header1">
        <div className="logo">
          <a href="/">
            <img src={logoIcon} alt="Logo" className="logo-icon" />
            <h1 className="logo-text">Art Generator</h1>
          </a>
        </div>
      </header>

      <div className="login-box">
        <h2 className="welcome-textt">Create Your Account</h2>
        <div className="social-buttons">
          <button className="social-button" onClick={handleGoogleSignIn}>
            <img src={googleIcon} alt="Google" className="social-icon" />
            Continue with Google
          </button>
          <button className="social-button">
            <img src={facebookIcon} alt="Facebook" className="social-icon" />
            Continue with Facebook
          </button>
        </div>
        <p className="or-continue-text">
          <span className="line-image"></span> or sign up with{" "}
          <span className="line-image"></span>
        </p>
        <div className="input-container1">
          <div className="input-box">
            <img src={profileIcon} alt="Profile" className="input-icon" />
            <input
              type="text"
              placeholder="Enter Username"
              className="text-input1"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="input-box">
            <img src={emailIcon} alt="Email" className="input-icon" />
            <input
              type="text"
              placeholder="Enter Email Address"
              className="text-input1"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-box">
            <img src={passwordIcon} alt="Password" className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              className="text-input1"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <img
              src={showPassword ? viewIcon : hideIcon}
              alt="Toggle Password"
              className="toggle-icon"
              onClick={togglePasswordVisibility}
            />
          </div>
          <div className="input-box">
            <img src={passwordIcon} alt="Password" className="input-icon" />
            <input
              type={showPassword1 ? "text" : "password"}
              placeholder="Confirm Password"
              className="text-input1"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <img
              src={showPassword1 ? viewIcon : hideIcon}
              alt="Toggle Password"
              className="toggle-icon"
              onClick={togglePasswordVisibility1}
            />
          </div>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {success && <p style={{ color: "green" }}>{success}</p>}
        <button className="signin-button" onClick={handleSignUp}>
          Sign Up
        </button>
        <p className="signup-text">
          Already have an account? <a href="/signin">Sign In</a>
        </p>
      </div>
    </div>
  );
};

export default SignUpPage;
